/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appVsts_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly vstsEnabled: boolean | null;
        readonly vstsAccount: ReadonlyArray<string | null> | null;
        readonly vstsEstimateField: string | null;
    } | null;
    readonly " $refType": "appVsts_viewer";
};
export type appVsts_viewer$data = appVsts_viewer;
export type appVsts_viewer$key = {
    readonly " $data"?: appVsts_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appVsts_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appVsts_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsEstimateField",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'd05a021adab46a0bd18fcf67d2dbdccc';
export default node;
